<template>
  <div>
    <footer
      class="footer fs18"
      v-if="!isH5"
    >
      <div class="footer_wrap">
        <el-row
          :gutter="20 "
          class="c_white"
        >
          <el-col :span="14">
            <el-row
              :gutter="20 "
              class="c_white"
            >
              <el-col
                :span="5"
                v-for="(item,index) in list"
                :key="index"
              >
                <ul
                  class="fs12 footer_four_ul margin-top-sm"
                  @click="goUrl(item.path)"
                >
                  <li
                    v-for="(litem,lindex) in item.title"
                    :key="lindex"
                    style="cursor:pointer;"
                  >
                    {{litem}}
                  </li>
                </ul>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="10">
            <div class="f-r-box">
              <div class="f-r-logo">
                <img
                  src="@/image/logo.png"
                  alt=""
                >
              </div>
              <div class="f-r-bottom">
                <div>友情链接 联系我们 网址地图 网站条款 隐私声明</div>
                <div
                  style="cursor: pointer;"
                  @click="goICP"
                >@粤ICP备2021060412号</div>
              </div>
            </div>
          </el-col>
        </el-row>

      </div>
    </footer>
    <footer
      v-if="isH5"
      class="m-footer"
    >
      <img
        src="@/image/logo.png"
        class="m-footer-logo"
        alt=""
      >
      <div class="m-footer-bottm c_white flex box-tb box-align-center">
        <div>友情链接 联系我们 网站地图 网站条款 隐私声明</div>
        <div
          style="cursor: pointer;"
          @click="goICP"
        >@粤ICP备2021060412号</div>
      </div>
    </footer>
  </div>
</template>

<script>
var caseN = null;
export default {
  props: {
    isH5: {
      type: Boolean,
      defalut: false
    }
  },
  data () {
    return {
      list: [{ title: ['家品首页', '产品展示', '产品品质'], path: 'index' }, { title: ['关于家品', '公司介绍', '园区展示'], path: "about" }, { title: ['公司产品', '热销产品', '全部产品'], path: "product" }, { title: ['联系家品', '联系我们'], path: "contact" }],

    };
  },
  methods: {
    goUrl (name) {
      this.$router.push({
        name
      })
    },
    goICP () {
      window.location.href = 'http://icp.chinaz.com/home/info?host=jiapin-food.com';
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/footb/index.vue